export function snapshotToArray(snapshot) {
  let array = []

  snapshot.forEach((childSnapshot) => {
    const item = childSnapshot.val()
    item.key = childSnapshot.key

    array.push(item)
  });

  return array
}



// WEBPACK FOOTER //
// ./src/utilities/firebase.utilities.js